import React from 'react';
import { HashRouter, Routes, Route, Link } from 'react-router-dom';
import FormsListPage from './pages/FormsListPage';
import FormBuilderPage from './pages/FormBuilderPage';
import FormResponsesPage from './pages/FormResponsesPage';

const AdminApp: React.FC = () => {
  return (
    <HashRouter>
      <div className="min-h-screen flex flex-col">
        <header className="sticky top-0 z-40 w-full border-b bg-background">
          <div className="container mx-auto flex h-16 items-center space-x-4 sm:justify-between sm:space-x-0 px-4">
            <Link to="/" className="flex items-center space-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
              <span className="font-bold">FormBuilder Pro - Admin</span>
            </Link>
            <nav className="flex items-center space-x-6 text-sm font-medium">
              <Link to="/" className="transition-colors hover:text-primary">Forms</Link>
            </nav>
          </div>
        </header>
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<FormsListPage />} />
            <Route path="/form/:formId/edit" element={<FormBuilderPage />} />
            <Route path="/form/:formId/responses" element={<FormResponsesPage />} />
            <Route path="*" element={<FormsListPage />} />
          </Routes>
        </main>
        <footer className="py-6 md:px-8 md:py-0 border-t">
          <div className="container mx-auto flex flex-col items-center justify-between gap-4 md:h-24 md:flex-row px-4">
            <p className="text-center text-sm leading-loose text-muted-foreground md:text-left">
              Built with React, Cloudflare Workers, and D1. Admin Interface.
            </p>
          </div>
        </footer>
      </div>
    </HashRouter>
  );
};

export default AdminApp;